<template lang='pug'>
div
  EditPaperModal
  ShareCollectionModal
  SelectCollectionModal
  CreateCollectionModal

  b-tabs(
    type="is-boxed",
    position="is-centered",
    @input="(value) => { onTabChanged(value); }"
  )
    b-tab-item(label="Search Paper", value=0, icon="search", icon-pack="fas")
      SearchResult
    b-tab-item(
      label="My Collections",
      value=1,
      icon="clipboard",
      icon-pack="fas"
    )
      CollectionPanel
</template>
<script>
import SearchResult from "./searchResult/SearchResult.vue";
import CollectionPanel from "./collections/CollectionPanel.vue";
import ShareCollectionModal from "./collections/ShareCollectionModal";
import EditPaperModal from "./collections/EditPaperModal";
import CreateCollectionModal from "./collections/CreateCollectionModal";
import SelectCollectionModal from "./collections/SelectCollectionModal";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    SearchResult,
    CollectionPanel,
    CreateCollectionModal,
    ShareCollectionModal,
    EditPaperModal,
    SelectCollectionModal,
  },
  created() {
    this.fetchCollections();
  },
  computed: {
    ...mapState("collection", {
      selectedCollectionId: (s) => s.selectedCollectionId,
    }),
  },
  methods: {
    ...mapActions("collection", ["fetchCollections", "fetchCollectionPapers"]),
    async onTabChanged(value) {
      if (value === "1") {
        await this.fetchCollections();
        if (this.selectedCollectionId !== null) {
          await this.fetchCollectionPapers({
            collectionId: this.selectedCollectionId,
          });
        }
      }
    },
  },
};
</script>